import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContextComponent';


const authorizeRoute = (route) => {
  const token = localStorage.getItem('token')
  if (token) {
    return route
  } else {
    return '/auth/signin'
  }
}

export default function Nav() {
  const { isLoggedIn, setIsLoggedIn} = useContext(AuthContext)
  const navigate = useNavigate()
  
  return (
    <nav className="flex justify-center items-center bg-silver bg-opacity-95 p-4 fixed bottom-0 left-0 right-0 z-40">
      <div className="flex-grow text-center">
        <Link to={authorizeRoute("/home")} className="navbar-link flex items-center justify-center">
          <div className="w-10 h-10 rounded flex items-center justify-center text-purple">
            <i className="fas fa-home"></i>
          </div>
        </Link>
      </div>
      <div className="flex-grow text-center">
        <Link to={authorizeRoute("/curb-it")} className="navbar-link flex items-center justify-center">
          <div className="w-10 h-10 rounded flex items-center justify-center text-purple">
            <i className="fas fa-plus"></i>
          </div>
        </Link>
      </div>
      <div className="flex-grow text-center">
        {isLoggedIn ? (   
      <button className="text-purple font-bold" onClick={() => navigate('/auth/signout')}>
       Logout
     </button>
        ) : (<div className="flex-grow text-center">
        <Link to="/auth/signin/" className="navbar-link flex items-center justify-center">
          <div className="w-10 h-10 rounded-full flex items-center justify-center text-purple">
            <i className="fas fa-user"></i>
          </div>
        </Link>
      </div>)}
          </div>
    </nav>
  );
}
